export enum PartialDisplayType {
    Embed = 0,
    Modal = 1,
}